export const URLS = {
  landingPage: '/',
  pricingPage: '/pricing',
  applyEarlyAccessPage: '/apply-early-access/essential',
  privacyPolicyPage: 'https://codestates.notion.site/salesclue-privacy',
  termsOfServicePage: 'https://codestates.notion.site/salesclue-policy',
  recruitmentInformationPage: 'https://codestates.career.greetinghr.com/home',
} as const;
